import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'strToTime' })
export class StrToTimePipe implements PipeTransform{
  transform(timeString: string) {
    let timeTokens = timeString.split(':');
    return new Date(1970,0,1, Number(timeTokens[0]), Number(timeTokens[1]), Number(timeTokens[2]));
  }
}
